(() => {
  const initialize = () => {
    if (window.__fisheCartBadgeSync || !document.querySelector('.shopify-section--header .header__cart-dot')) {
      return;
    }

    window.__fisheCartBadgeSync = true;

    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = new URL((root.endsWith('/') ? root : root + '/') + 'cart.js', window.location.origin);
    let timer;
    let revision = 0;
    let retries = 0;

    const setCount = (quantity) => {
      const count = Number(quantity);
      if (!Number.isSafeInteger(count) || count < 0) {
        return;
      }

      document.querySelectorAll('.shopify-section--header .header__cart-dot').forEach((badge) => {
        badge.classList.toggle('is-visible', count > 0);
      });

      document.querySelectorAll('.shopify-section--header cart-count').forEach((label) => {
        label.textContent = String(count);
      });
    };

    const readCart = async () => {
      const requestRevision = ++revision;

      try {
        const response = await fetch(cartUrl.href, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          throw new Error('Unable to read cart');
        }

        const cart = await response.json();
        if (requestRevision === revision) {
          retries = 0;
          setCount(cart.item_count);
        }
      } catch {
        if (requestRevision === revision && retries < 1) {
          retries += 1;
          schedule(800);
        }
      }
    };

    const schedule = (delay = 80) => {
      revision += 1;
      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = undefined;
        void readCart();
      }, delay);
    };

    document.addEventListener('cart:change', (event) => {
      if (event.detail?.cart?.item_count !== undefined) {
        setCount(event.detail.cart.item_count);
      }
      retries = 0;
      schedule(80);
    });

    document.addEventListener('cart:refresh', () => {
      retries = 0;
      schedule(80);
    });

    document.addEventListener('shopify:cart:lines-update', (event) => {
      retries = 0;
      const operation = event.promise || event.detail?.promise;
      if (operation && typeof operation.then === 'function') {
        operation.then(() => schedule(0), () => schedule(0));
      } else {
        schedule(350);
      }
    });

    if (typeof PerformanceObserver !== 'undefined' && PerformanceObserver.supportedEntryTypes?.includes('resource')) {
      const observer = new PerformanceObserver((list) => {
        const changed = list.getEntries().some((entry) => {
          if (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest') {
            return false;
          }

          try {
            const url = new URL(entry.name, window.location.href);
            return url.origin === window.location.origin && /\/cart\/(add|change|update|clear)\.js$/i.test(url.pathname);
          } catch {
            return false;
          }
        });

        if (changed) {
          retries = 0;
          schedule(100);
        }
      });

      observer.observe({ type: 'resource', buffered: false });
    }

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      if (event.target.closest('#cart-drawer, .cart-drawer')) {
        schedule(450);
      } else if (event.target.closest('form[action*="/cart/add"] button[type="submit"], button[name="add"]')) {
        schedule(650);
      }
    }, { capture: true });

    document.addEventListener('change', (event) => {
      if (event.target instanceof Element && event.target.closest('#cart-drawer, .cart-drawer')) {
        schedule(450);
      }
    }, { capture: true });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        schedule(0);
      }
    });

    window.addEventListener('pageshow', () => schedule(0));
    schedule(0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
